<template>
    <b-modal
        id="chapter-modal"
        centered 
        size="lg"
        body-class="d-flex flex-column p-3 f-narkis"
        header-class="bg-primary text-white"
        footer-class="border-top"
        ok-variant="secondary"
        :ok-title="hebrew ? 'סגור' : 'Close'"
        ok-only
        v-model="show"
        @show="scrollIntoView"
    >
        <template slot="modal-header">
          <h3 class="my-0">{{$store.state.verseForChapter.verseDispHeb}}</h3>
          <small class="xd-none"><a class="text-white" :href = "verseId" target="_blank" rel="noopener noreferrer">
            {{hebrew ? 'צפה בפרושים וחידושים [ספריא] ' : 'View more on Sefaria'}}
          </a></small>
        </template>
        <ul class="verses-list p-0 m-0">
          <li 
            v-for="(item, key) in $store.state.chapterResults.text" v-bind:key="key"
            v-bind:class="{ active: item.containsMatch }">
            <div class="row mb-1">
              <div class="col-2 col-sm-1"><small class="pasuk-header">{{item.label}}</small></div>
              <div class="d-inline-block text-right pl-2"><p v-html="item.text" class="my-0"></p></div>
            </div>
          </li>
        </ul>
    </b-modal>
</template>

<script>
export default {
  name: 'ChapterPopup',
  props: ['value'],
  methods: {
    scrollIntoView() {
      setTimeout(function() {
        document.getElementsByClassName('active')[0].
        scrollIntoView({ behavior: "smooth", block: "start" });  
      }, 500)  
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },     
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    verseId: function() {
      let verseId = this.$store.state.verseForChapter.verseId
      let mode = this.$store.state.verseForChapter.mode
      if(verseId) {       
        let url = 'http://www.sefaria.org/' + verseId.split('.').slice(-3).join('.')
        if (mode === 'Talmud')        
          url =  url.replace(/.([^.]*)$/, '$1')
        if (this.hebrew)  
          url = url + '?lang=he'
        else
          url = url + '?lang=en'
        return url      
       } else {
        return ''
      }       
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  #chapter-modal{
    header{
      direction: rtl;
    }
  }
</style>
<style lang="scss" scoped>
  .d-inline-block{
    max-width: 90%;
    @media only screen and (max-width: 676px) {
      max-width: 80%;
    }
  }
  .verses-list{
    direction: rtl;
  }
  .active{
    .row div{
      background-color: #d6ecff;
      border-radius: 2px;
    }
  }
  ul{
    max-height: 70vh;
    overflow-y: auto;
  }
  li{
    padding-right:7px;
    list-style-type: none;
    width:96%;
  }
  .pasuk-header{
    font-family: 'Arimo';
  }
</style>
